import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Form, Typography } from 'antd';

import { useRouteMatchParam } from '@/hooks';

import {
  CompositionPriceFormInterface,
  CostItemsFieldsOptions,
} from '@/core/domain/stock/Configuration/Configuration.types';
import { useCompanyStockConfiguration } from '@/core/domain/stock/Configuration/Configuration.hooks';

import { PageProps } from '@/types/PageProps';
import CompanyStockPriceCompositionForm from '@/components/Companies/Settings/CompanyStockPriceCompositionForm';
import { useCompanyFormContext } from '@/components/Companies/CompaniesFormProvider';
import { SaveButton } from '@/components/_common';

const { Title } = Typography;

function CompanyPriceCompositionPage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<CompositionPriceFormInterface>();
  const companyId = +useRouteMatchParam('companyId');
  const {
    formValues,
    isLoading: contextLoading,
    handleSubmit,
    disabled,
  } = useCompanyFormContext();

  const { data, isLoading } = useCompanyStockConfiguration(companyId);

  useEffect(() => {
    if (data?.result) {
      form.setFieldsValue({
        ...data.result.costItems.reduce((prev, curr) => {
          if (curr.active) {
            const field = CostItemsFieldsOptions[curr.field];

            return { ...prev, [field]: true };
          }
          return prev;
        }, {}),
      });
    }
  }, [data]);

  useEffect(() => {
    if (formValues.companyCompositionPrice) {
      form.setFieldsValue(formValues.companyCompositionPrice);
    }
  }, [formValues.companyCompositionPrice]);

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div className="page">
        <div className="page-header" style={{ marginBottom: '24px' }}>
          <Title level={3}>
            <FormattedMessage id="companies.settings.priceComposition" />
          </Title>

          <SaveButton
            onClick={handleSubmit}
            loading={contextLoading}
            disabled={disabled}
          >
            <FormattedMessage id="commons.entity.save" />
          </SaveButton>
        </div>

        <CompanyStockPriceCompositionForm form={form} isLoading={isLoading} />
      </div>
    </>
  );
}

export default CompanyPriceCompositionPage;
